<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<template>
  <div class="mt-6 flex flex-row" v-if="load_data">
    <div :class="{ 'basis-full': !show_batch, 'basis-1/4': show_batch }">
      <badge-default class="mb-2" :label="`Lotes: ${total_harvested_batches}`" />
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table
              :class="[show_batch ? 'hidden md:table' : 'table']"
              class="min-w-full"
            >
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell sticky z-10">
                    {{ $t("model.harvested_batch.week") }}
                  </th>
                  <th
                    v-if="!show_batch"
                    scope="col"
                    class="table-header-cell sticky z-10"
                  >
                    {{ $t("model.harvested_batch.registered_at") }}
                  </th>
                  <th scope="col" class="table-header-cell sticky z-10">
                    {{ $t("model.harvested_batch.batch_code") }}
                  </th>
                  <th
                    v-if="!show_batch"
                    scope="col"
                    class="table-header-cell sticky z-10"
                  >
                    {{ $t("model.harvested_batch.crop_field") }}
                  </th>
                  <th
                    v-if="!show_batch"
                    scope="col"
                    class="table-header-cell sticky z-10"
                  >
                    {{ $t("model.harvested_batch.harvested_packages") }}
                  </th>
                  <th
                    v-if="!show_batch"
                    scope="col"
                    class="table-header-cell sticky z-10"
                  >
                    {{ $t("model.harvested_batch.total_weight") }}
                  </th>
                  <th
                    v-if="!show_batch"
                    scope="col"
                    class="table-header-cell sticky z-10"
                  >
                    {{ $t("model.harvested_batch.discarded_weight") }}
                  </th>
                  <th
                    v-if="!show_batch"
                    scope="col"
                    class="table-header-cell sticky z-10"
                  ></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  v-for="(harvested_batch, index) in harvested_batches"
                  :key="index"
                  :class="{
                    'table-row': true,
                    'bg-gray-300':
                      show_batch &&
                      harvested_batch.id == this.harvested_batch.id
                  }"
                >
                  <td class="table-cell">{{ harvested_batch.week }}</td>
                  <td v-if="!show_batch" class="table-cell">
                    {{ dateFormatter(harvested_batch.registered_at) }}
                  </td>
                  <td class="table-cell">
                    <button
                      @click.prevent="showBatch(harvested_batch)"
                      class="link"
                    >
                      {{ harvested_batch.batch_code }}
                    </button>
                  </td>
                  <td v-if="!show_batch" class="table-cell">
                    {{ harvested_batch.crop_field?.name }}
                  </td>
                  <td v-if="!show_batch" class="table-cell">
                    <template
                      v-for="(number, har_pk_name, idx) in harvestedPackages(
                        harvested_batch
                      )"
                      :key="idx"
                    >
                      {{ number }} {{ har_pk_name }}
                    </template>
                  </td>
                  <td v-if="!show_batch" class="table-cell">
                    {{ numberWithPrecision(harvested_batch.total_weight) }}
                  </td>
                  <td v-if="!show_batch" class="table-cell">
                    {{ numberWithPrecision(harvested_batch.discarded_weight) }}
                  </td>
                  <td v-if="!show_batch" class="table-cell">
                    <div class="inline-flex items-center">
                      <b class="text-[#5c7a2e] pr-1">{{
                        harvested_batch.ok_percent
                      }}</b>
                      <div
                        class="w-48 h-1.5 bg-red-500 overflow-hidden rounded-full"
                      >
                        <div
                          class="bg-[#5c7a2e] h-1.5"
                          :style="{
                            width: `${harvested_batch.ok_percent}%`
                          }"
                        ></div>
                      </div>
                      <b class="text-red-600 pl-1">{{
                        harvested_batch.discarded_percent
                      }}</b>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <table-paginator
        v-model="current_page"
        :total_rows="total_harvested_batches"
        :rows_per_page="rows_per_page"
      />
    </div>
    <div v-if="show_batch && harvested_batch" class="basis-3/4 pl-4 mt-8">
      <a @click.prevent="show_batch = false" class="btn-white">
        <i class="fa fa-angle-left mr-2"></i>Volver a la lista de lotes
      </a>
      <div class="panel">
        <div class="panel-body">
          <div class="grid grid-cols-1 gap-y-8 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.week") }}
              </dt>
              <dd class="content-data">
                {{ harvested_batch.week }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.registered_at") }}
              </dt>
              <dd class="content-data">
                {{ dateFormatter(harvested_batch.registered_at) }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">Lote</dt>
              <dd class="content-data">
                {{ harvested_batch.batch_code }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">Empaques</dt>
              <dd class="content-data">
                <template
                  v-for="(number, har_pk_name, idx) in harvestedPackages(
                    harvested_batch
                  )"
                  :key="idx"
                >
                  {{ number }} {{ har_pk_name }}
                </template>
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">Total cosechado</dt>
              <dd class="content-data">
                {{ numberWithPrecision(harvested_batch.total_weight) }} Kg
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">Descarte</dt>
              <dd class="content-data">
                {{ numberWithPrecision(harvested_batch.discarded_weight) }}
                Kg
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">Campo</dt>
              <dd class="content-data">
                {{ harvested_batch.crop_field?.name }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">Variedad</dt>
              <dd class="content-data">
                {{ harvested_batch.crop_variety.name }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">Cuadrilla</dt>
              <dd class="content-data">
                {{ harvested_batch.harvest_team?.name }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">Motivos de descarte</dt>
              <dd class="content-data">
                <ul class="list-disc list-inside">
                  <li v-for="(motive, i) in harvested_batch.discarded_motives" :key="i">
                    {{ motive.name }}
                  </li>
                </ul>
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">Calibres</dt>
              <dd class="content-data">
                <ul class="list-disc list-inside">
                  <li
                    v-for="(
                      harvested_exp_package, idx
                    ) in harvested_batch.harvested_exp_packages"
                    :key="idx"
                  >
                    <b>{{ harvested_exp_package.crop_size.name }}:</b>
                    {{ numberWithPrecision(harvested_exp_package.number) }}
                    Kg
                  </li>
                </ul>
              </dd>
            </div>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-1 gap-y-8 gap-x-4 sm:grid-cols-2">
        <div class="panel">
          <div class="panel-body">
            <reasons-discard :series="discarded_series" :labels="discarded_labels" />
          </div>
        </div>
        <div class="panel">
          <div class="panel-body">
            <percentage-discard :series="[discard_percent]" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Requester from "@/views/producer/requesters/reporting/process/show_reports.js";

import TablePaginator from "@/components/views/layout/TablePaginator.vue";
import ReasonsDiscard from "@/components/views/producer/reporting/process/charts/ReasonsDiscard.vue";
import PercentageDiscard from "@/components/views/producer/reporting/process/charts/PercentageDiscard.vue";
export default {
  name: "PRODReportingProcessShowReportsDetails",
  components: { ReasonsDiscard, PercentageDiscard, TablePaginator },
  props: {
    producer_id: { required: true },
    agro_exporter_process_id: { required: true }
  },
  data() {
    return {
      load_data: false,
      current_page: 1,
      total_harvested_batches: 0,
      rows_per_page: 14,
      show_batch: false,
      harvested_batch: null,
      harvested_batches: [],
    };
  },
  computed: {
    harvested_batches_with_percents() {
      return this.harvested_batches.filter(
        harvested_batch => harvested_batch.discarded_weight > 0
      );
    },
    discard_percent() {
      if (this.harvested_batch == null) return 0;
      return (
        (Number(this.harvested_batch.discarded_weight) /
          Number(this.harvested_batch.total_weight)) *
        100
      );
    },
    discarded_series() {
      if (this.harvested_batch == null) return [];
      return this.harvested_batch.discarded_motives.map(dm => dm.value);
    },
    discarded_labels() {
      if (this.harvested_batch == null) return [];
      return this.harvested_batch.discarded_motives.map(dm => dm.name);
    }
  },
  created() {
    this.fetchTotalPages();
    this.fetchHarvestedBatches();
  },
  methods: {
    async showBatch(harvested_batch) {
      await this.fetchHarvestedBatch(harvested_batch);
      this.show_batch = true;
    },
    async fetchHarvestedBatch(harvested_batch) {
      let { data } = await Requester.fetchHarvestedBatch(
        this.producer_id,
        this.agro_exporter_process_id,
        harvested_batch.id
      );
      this.harvested_batch = data;
    },
    harvestedPackages(harvested_batch) {
      return harvested_batch.harvested_packages.reduce((p, har_pkg) => {
        let name = har_pkg.crop_har_package.name;
        if (!Object.hasOwn(p, name)) p[name] = 0;
        p[name] += har_pkg.number;
        return p;
      }, {});
    },
    fetchHarvestedBatches: async function () {
      let response = await Requester.fetchHarvestedBatches(
        this.producer_id,
        this.agro_exporter_process_id,
        this.current_page - 1,
        this.rows_per_page
      );
      this.harvested_batches = response.data;
      this.fillPercentValues();
      this.load_data = true;
    },
    fetchTotalPages: async function () {
      let response = await Requester.fetchHarvestedBatchesTotal(
        this.producer_id,
        this.agro_exporter_process_id
      );
      this.total_harvested_batches = response.data;
    },
    fillPercentValues() {
      this.harvested_batches.forEach(harvested_batch => {
        const discarded_percent = this.discardPercent(harvested_batch);
        harvested_batch["discarded_percent"] = discarded_percent;
        harvested_batch["ok_percent"] = 100 - discarded_percent;
      });
    },
    discardPercent(harvested_batch) {
      if (Number(harvested_batch.total_weight) == 0) return 0;
      let percent =
        (Number(harvested_batch.discarded_weight) /
          Number(harvested_batch.total_weight)) *
        100;
      return Math.round(percent);
    }
  },
  watch: {
    current_page: function () {
      this.fetchHarvestedBatches();
    }
  }
};
</script>
